export const FREIGHT_VIEW_ID = 'freight';
export const FREIGHT_PENDING_QUOTES_VIEW_ID = 'freight-pending-quotes';
export const FREIGHT_BOOKED_VIEW_ID = 'freight-booked';
export const FREIGHT_CANCELLED_VIEW_ID = 'freight-cancelled';
